import React from 'react'

import { ThemeProvider } from '@gousto-internal/citrus-react'
import PropTypes from 'prop-types'
import { Provider } from 'react-redux'
import { Router, applyRouterMiddleware } from 'react-router'
import { useScroll as setScroll } from 'react-router-scroll'
import { SWRConfig } from 'swr'

import { RibbonIsAuthenticatedAttributeReporter } from 'components/RibbonTrigger'
import { SetupOptimizelyOverride } from 'containers/OptimizelyRollouts'
import { fetchContentOnChange } from 'routes/fetchContentOnChange'
import { hashLinkScroll } from 'routes/hashLinkScroll'
import { shouldScroll } from 'routes/shouldScroll'
import { trackPageChange } from 'routes/trackPageChange'
import { canUseWindow } from 'utils/browserEnvironment'
import { executeVirtualView } from 'utils/usabilla'
import { documentLocation } from 'utils/window'
import { ApplePayStatusFetch } from 'ApplePayStatusFetch/ApplePayStatusFetch'

export const AppContainer = ({ history, routes, store }) => (
  <Provider store={store}>
    <SetupOptimizelyOverride />
    <ApplePayStatusFetch />
    <SWRConfig
      value={{
        revalidateOnFocus: false,
      }}
    >
      <ThemeProvider>
        <Router
          history={history}
          render={canUseWindow() ? applyRouterMiddleware(setScroll(shouldScroll)) : undefined}
          onUpdate={() => {
            trackPageChange(store)
            hashLinkScroll()
            fetchContentOnChange(documentLocation().pathname, store)
            executeVirtualView()
          }}
        >
          {routes}
        </Router>
        <RibbonIsAuthenticatedAttributeReporter />
      </ThemeProvider>
    </SWRConfig>
  </Provider>
)

AppContainer.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  history: PropTypes.object.isRequired,
  routes: PropTypes.node.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  store: PropTypes.object.isRequired,
}
